import React from 'react'
import { Flex, Text, Link, IconButton } from 'components/ds'

import styles from './CancelSubscriptionBanner.module.css'
import clsx from 'clsx'
import { MdClose } from '@react-icons/all-files/md/MdClose'
import { plural } from '@disco/utils/string-utils'
import { useCancellationBanner } from './CancellationBannerProvider'

export function CancelSubscriptionBanner() {
  const {
    shouldShowBanner,
    daysRemainingUntilCancellation,
    setScheduledCancellationBannerDismissedAt,
  } = useCancellationBanner()

  if (!shouldShowBanner) {
    return null
  }

  const hasExpired =
    daysRemainingUntilCancellation == null ||
    daysRemainingUntilCancellation <= 0

  return (
    <Flex
      align="center"
      justify="center"
      py="9px"
      px="5"
      className={clsx(
        styles['CancelSubscriptionBanner--box'],
        daysRemainingUntilCancellation != null &&
          daysRemainingUntilCancellation > 3 &&
          styles['CancelSubscriptionBanner--box-warning'],
      )}
    >
      <Text
        size="2"
        weight="medium"
        className={styles['CancelSubscriptionBanner--text']}
      >
        {hasExpired ? (
          <span>Your subscription has expired. Something not right? </span>
        ) : (
          <span>
            You have{' '}
            {plural(daysRemainingUntilCancellation ?? 0, 'day', 'days')}{' '}
            remaining until your subscription expires. Didn’t mean to cancel?{' '}
          </span>
        )}
        <Link
          href="#"
          data-testid="start-generic-intercom-workflow-banner"
          className={clsx(
            'inline-link',
            styles['CancelSubscriptionBanner--link'],
          )}
        >
          Contact support
        </Link>
      </Text>
      {!hasExpired && (
        <IconButton
          className={styles['CancelSubscriptionBanner--close-button']}
          size="3"
          variant="ghost"
          onClick={() => setScheduledCancellationBannerDismissedAt(new Date())}
        >
          <MdClose color="#fff" size="24px" />
        </IconButton>
      )}
    </Flex>
  )
}
